import { Anchor, Checkbox, Flex, Text } from '@mantine/core'
import Link from 'next/link'

import { Trans, useTranslation } from '@flecto/translations'

type CheckboxWithDescriptionProps = {
  label: string
  description: string
  value?: boolean
  onChange?: (value: boolean) => void
  disabled?: boolean
}

export function CheckboxWithDescription({
  label,
  description,
  value,
  onChange,
  disabled = false,
}: CheckboxWithDescriptionProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_bookings' })

  return (
    <Flex direction='column'>
      <Checkbox
        label={label}
        checked={value}
        onChange={() => onChange?.(!value)}
        disabled={disabled}
      />
      {label === t('label_include_terms') ? (
        <Text c='dimmed' size='sm' ml='lg' pl='xs'>
          <Trans
            ns='saas'
            i18nKey={'profile_bookings.label_include_terms_description'}
            components={{
              a: (
                <Anchor
                  component={Link}
                  c='dimmed'
                  underline='always'
                  href='/profile/business'
                />
              ),
            }}
          />
        </Text>
      ) : (
        <Text c='dimmed' size='sm' ml='lg' pl='xs'>
          {description}
        </Text>
      )}
    </Flex>
  )
}
